export default __webpack_public_path__ + "static/media/Convergence Training.d068ea60.png";